import React, { useState } from "react"
import types from "prop-types"
import CategoryResetContext from "../CategoryResetContext"

const RESET_STATE = {
  id: null,
  status: null,
}

const CategoryResetContextProvider = ({ children }) => {
  const [categoryReset, setCategoryReset] = useState({ ...RESET_STATE })

  const clearCategoryReset = () => setCategoryReset({ ...RESET_STATE })

  // Object exposed to context consumers
  const contextConsumerValue = {
    categoryReset,
    setCategoryReset,
    clearCategoryReset,
  }

  return (
    <CategoryResetContext.Provider value={contextConsumerValue}>
      {children}
    </CategoryResetContext.Provider>
  )
}

CategoryResetContextProvider.propTypes = {
  children: types.node.isRequired,
}

export default CategoryResetContextProvider
